/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Number_To_Keep_LabelInputs */

const en_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Backups to Keep`)
};

const fr_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de sauvegardes à conserver`)
};

const de_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der aufzubewahrenden Backups`)
};

const it_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di backup da conservare`)
};

const ru_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество резервных копий, которые необходимо хранить`)
};

const es_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de copias de seguridad a mantener`)
};

const zh_cn2_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要保留的备份数量`)
};

const ja_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存するバックアップの数`)
};

const hi_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैकअप की संख्या जिसे रखना है`)
};

const pt_pt2_options_backup_number_to_keep_label = /** @type {(inputs: Options_Backup_Number_To_Keep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de backups a manter`)
};

/**
* | output |
* | --- |
* | "Number of Backups to Keep" |
*
* @param {Options_Backup_Number_To_Keep_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_number_to_keep_label = /** @type {((inputs?: Options_Backup_Number_To_Keep_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Number_To_Keep_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_number_to_keep_label(inputs)
	if (locale === "de") return de_options_backup_number_to_keep_label(inputs)
	if (locale === "it") return it_options_backup_number_to_keep_label(inputs)
	if (locale === "ru") return ru_options_backup_number_to_keep_label(inputs)
	if (locale === "es") return es_options_backup_number_to_keep_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_number_to_keep_label(inputs)
	if (locale === "ja") return ja_options_backup_number_to_keep_label(inputs)
	if (locale === "hi") return hi_options_backup_number_to_keep_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_number_to_keep_label(inputs)
	return en_options_backup_number_to_keep_label(inputs)
});